import React, { Component } from 'react';
import { connect } from 'react-redux';
import { PropTypes } from 'prop-types';
import * as actions from './ducks/actions';
import { isEnglishActive, isFrenchActive } from '../../store/rootReducer';
import { Language } from './services/constants';
import Api from '../../services/api/Api';
import auth from '../user/services/Auth';
import "./LanguageToggle.scss"
import {ApiPaths} from "../../services/api/ApiPaths";

class LanguageToggle extends Component {

  setLanguage = (language) => {
    this.props.setLanguage(language);
    if (auth.isAuthenticated()) {
      Api.put(ApiPaths.UPDATE_ACCOUNT_LANGUAGE, {lang: language});
    }
  };

  render() {
    let { isEnglishActive, isFrenchActive } = this.props;
    return (
        <div className="btn-group hrb-lang-toggle">
          <div
              className={"btn hrb-lang-toggle-btn " + (isEnglishActive ? 'hrb-lang-toggle-btn-active' : '')}
              onClick={() => this.setLanguage(Language.ENGLISH)}>
            En
          </div>
          <div
              className={"btn hrb-lang-toggle-btn " + (isFrenchActive ? 'hrb-lang-toggle-btn-active' : '')}
              onClick={() => this.setLanguage(Language.FRENCH)}>
            Fr
          </div>
        </div>
    );
  }
}

LanguageToggle.propTypes = {
  isEnglishActive: PropTypes.bool.isRequired,
  isFrenchActive: PropTypes.bool.isRequired,
  setLanguage: PropTypes.func.isRequired
};

const mapStateToProps = (state) => {
  return {
    isEnglishActive: isEnglishActive(state),
    isFrenchActive: isFrenchActive(state)
  }
};

export default connect(
  mapStateToProps,
  actions
)(LanguageToggle);
